import { SharedModule } from '../../../../shared/shared.module';
import {NgModule} from '@angular/core';
import {CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
import {MatDividerModule} from '@angular/material/divider';
import {MatDialogModule} from '@angular/material/dialog';
import { RunbookPopupComponent } from './runbook-popup.component';
import {IconsModule} from '../../../../icons/icons.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ErrorModule } from 'src/app/components/error/error.module';
import {TranslocoModule} from '@jsverse/transloco';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { RedirectionDialogModule } from 'src/app/components/redirection-dialog/redirection-dialog.module';

@NgModule({
  declarations: [RunbookPopupComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatDividerModule,   
    MatDialogModule,
    IconsModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorModule,
    TranslocoModule,
    NgxSkeletonLoaderModule,
    RedirectionDialogModule,
    TitleCasePipe
  ],
  providers: [
  DatePipe
]
})
export class RunbookPopupModule {
}